import { Button, Modal } from 'antd';
import React, { useContext, useState } from 'react';
import { StoreContext } from '../../../store/store';

export default function AssociateWithCompanyModal() {
  const {
    showAssociateToCompany,
    setShowAssociateToCompany,
    user
  } = useContext(StoreContext);

  const handleClose = () => {
    setShowAssociateToCompany({status: false, fun: () => null});
  };

  const handleOk = () => {
    showAssociateToCompany.fun()
    setShowAssociateToCompany({status: false, fun: () => null});
  }

  return (
    <>
      <Modal
        title="User is not associated with a company"
        visible={showAssociateToCompany.status}
        onOk={handleOk}
        onCancel={handleClose}
        footer={[
          <Button key="close" type="default" onClick={handleClose}>Close </Button>,
        ]}
      >
        <p>
          Your email address {user.userName} is not associated with a company.
          If you need the invoice to be VAT claimable, please update your user details
          to associate your user details with a company and a corresponding VAT number.
        </p>
        <p>
          Contact customer care mike@dhigroup.com to have your user profile associated with a company.
        </p>
      </Modal>
    </>
  );
}
